export default "__VITE_ASSET__3475fbe9__"